import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
import { images } from '../data/checkout';
const FIRST_DELAY = 5000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timer: number;
    const show = () => {
      setVisible(true);
      timer = window.setTimeout(hide, VISIBLE_FOR);
    };
    const hide = () => {
      setVisible(false);
      timer = window.setTimeout(() => {
        setIndex(i => (i + 1) % buyers.length);
        show();
      }, GAP);
    };
    timer = window.setTimeout(show, FIRST_DELAY);
    return () => window.clearTimeout(timer);
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 sm:bottom-6 sm:left-6 sm:right-auto" aria-live="polite" data-id="element-234" data-mp="165poymp4dchp">
      <AnimatePresence data-id="element-235" data-mp="1164p8a24l03x">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-card sm:w-[360px]" data-id="element-236" data-mp="1fviv386hszek">
            <img src={images.hero} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-canvas object-contain" data-id="element-237" data-mp="x6m35aykiizi" />
            <div className="min-w-0" data-id="element-238" data-mp="s8asiy0g84g8">
              <p className="text-[15px] leading-snug text-ink" data-id="element-239" data-mp="28jyahvtjdjqf">
                <strong data-id="element-240" data-mp="28mkexml4rj4f">{buyer.name}</strong> from <strong data-id="element-241" data-mp="23lwg4eqntxzn">{buyer.country}</strong> just purchased{' '}
                <span className="font-semibold text-brand" data-id="element-242" data-mp="23npobygx8q9r">Obesity Clinical Blueprint™</span>
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs font-medium text-muted" data-id="element-243" data-mp="2fno139kjn9zm">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-cta" aria-hidden="true" data-id="element-244" data-mp="2fphb8yud8ccd" />
                Verified purchase · {buyer.minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-muted hover:bg-canvas hover:text-ink" data-id="element-245" data-mp="2pl2ef0b67inp">
              <XIcon className="h-4 w-4" data-id="element-246" data-mp="21v834n6i225k" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}